import Entity from './entity'
export default class outair_equipment extends Entity<number>{
    Id:number;
    sNID:string;
    status:Number=1;
    etype:Number=1;
    ftId:Number;
    wId:Number;
    fId:Number;
}